import swal from 'sweetalert'
import { createEvent } from '../_helpers'

export function apiRequest(module, action, body) {
  return fetch(`/estimation/api/${module}/${action}`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: body ? JSON.stringify(body) : undefined,
  })
}

/**
 * Force value of an input to match pattern like: +1234567890
 * @param {HTMLInputElement} input
 */
export function phoneMask(input) {
  if (!input.value.match()) {
    input.value = input.value.replace(/[^\d]/g, '')
  }
  if (input.value.length > 0 && input.value[0] !== '+') {
    input.value = `+${input.value}`
  }
  input.dispatchEvent(new Event('input'))
}

export function handleError(res, defaultMessage = '') {
  res.json().then(json => {
    let message = defaultMessage
    if (typeof json.Message === 'string') {
      message = json.Message
    } else if (typeof json === 'string') {
      message = json
    }
    swal(message, '', 'error')
  })
}

export const initialValues = {
  type: 'house',

  locality: 'Genève',
  street: 'Quai Gustave-Ador',
  streetNumber: '82',
  zip: '1207',
  latitude: '46.207693',
  longitude: '6.169359300000002',
  isLocationValid: true,

  usetype: '1',
  stype: '1',
  subtype: '1',

  'land-area': '800',
  rooms: '1',
  area: '200',
  building: '200',
  year: '2013',
  standard: '1',
  condition: '1',
  title: 'Mr',
  surname: 'Doe',
  name: 'John',
  tel: '+417980868687',
  email: 's.pitetsky@ewm.swiss',
  reason: 'purchase',
  policy: true,
  code: '9999',
}

export const setInitialValues = form => {
  Object.entries(initialValues).forEach(([name, value]) => {
    const inputs = form.querySelectorAll(`[name="${name}"]`)

    if (inputs.length > 1) {
      const radioToCheck = Array.prototype.find.call(
        inputs,
        i => i.value === value
      )
      if (radioToCheck) {
        radioToCheck.checked = true
        // radioToCheck.dispatchEvent(new Event('input'))
        radioToCheck.dispatchEvent(createEvent('change'))
      }
    } else if (inputs.length === 1) {
      const input = inputs[0]
      if (input.type === 'checkbox' && value === true) {
        input.checked = true
      } else {
        input.value = value
      }
      // input.dispatchEvent(new Event('input'))
      input.dispatchEvent(createEvent('change'))
    }
  })
}

export function setRequireAttributeForInputs(section, state) {
  section
    .querySelectorAll('input')
    .forEach(input =>
      state
        ? input.hasAttribute('data-required') &&
          input.setAttribute('required', true)
        : input.removeAttribute('required')
    )
}
